var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.oferta)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"small":"","icon":"","target":"_blank","link":!_vm.isMarketplace,"href":_vm.url}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)]}}],null,false,1070190241)},[_c('span',[_vm._v(" Abrir oferta ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }